export default __webpack_public_path__ + "static/media/eleven.26d03b58.svg";